export const TEXTS = {
    LINK_TEXT: "Proceed to link {0} with email id and number:",
    LINK_TEXT_V4: "Proceed to link {0} with:",
};

export const META_POINT_ICON_WIDTH = 18;
